/* Gsap */
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class Anime {
	constructor(el) {
		this.el = el;
		this.init();
	}

	init() {
		this.scrollTrigger = this.hasScrolltrigger() ? true : false;
		this.type = this.el.dataset.hwcAnime;
		this.el = this.el.dataset.animeChildren
			? Array.from(this.el.children)
			: this.el;
		this.stagger = 0.2;

		switch (this.type) {
			case "heroheading":
				this.revealHeroHeading();
				break;
			case "heading":
				this.revealHeading();
				break;
			case "supheading":
				this.revealSupHeading();
				break;
			case "parallax":
				this.parallax();
				break;
			case "translateY":
				this.translateY();
				break;
		}

		this.toggleClass();
	}

	translateY() {
		if (this.scrollTrigger) {
			this.scrollTrigger = {
				trigger: this.el,
				start: "top bottom",
			};
		}

		gsap.fromTo(
			this.el,
			{
				autoAlpha: 0,
				y: 34,
				scale: 0.96,
				rotateZ: -1.2,
				yPercent: 0,
				force3D: false,
			},
			{
				scrollTrigger: this.scrollTrigger,
				ease: "back.out(1.8)",
				y: 0,
				autoAlpha: 1,
				scale: 1,
				rotateZ: 0,
				yPercent: 0,
				force3D: false,
				duration: 0.9,
				stagger: this.stagger,
			},
		);
	}

	revealSupHeading() {
		if (this.scrollTrigger) {
			this.scrollTrigger = {
				trigger: this.el,
				start: "clamp(top bottom)",
			};
		}
		let label = this.el.querySelector("[data-supheading-label]");
		if (!label) {
			const content = this.el.innerHTML;
			this.el.innerHTML = `<span data-supheading-label>${content}</span>`;
			label = this.el.querySelector("[data-supheading-label]");
		}

		gsap.set(this.el, { transformOrigin: "0% 50%", overflow: "hidden" });
		gsap.set(label, { display: "inline-block", autoAlpha: 0, y: 6 });

		const tl = gsap.timeline(
			this.scrollTrigger ? { scrollTrigger: this.scrollTrigger } : {},
		);

		tl.fromTo(
			this.el,
			{
				scaleX: 0,
				y: 8,
			},
			{
				scaleX: 1,
				y: 0,
				duration: 0.55,
				ease: "back.out(2.2)",
			},
		).to(
			label,
			{
				autoAlpha: 1,
				y: 0,
				duration: 0.28,
				ease: "power2.out",
			},
			">",
		);
	}

	revealHeading() {
		if (this.scrollTrigger) {
			this.scrollTrigger = {
				trigger: this.el,
				start: "clamp(top bottom)",
			};
		}

		SplitText.create(this.el, {
			type: "lines, words",
			autoSplit: true,
			onSplit: (self) => {
				gsap.set(self.lines, { overflow: "hidden" });

				gsap.fromTo(
					self.words,
					{
						autoAlpha: 0,
						yPercent: 30,
					},
					{
						autoAlpha: 1,
						yPercent: 0,
						duration: 0.65,
						ease: "power2.out",
						scrollTrigger: this.scrollTrigger,
						stagger: {
							each: 0.018,
							from: "start",
						},
					},
				);
			},
		});
	}

	revealHeroHeading() {

		if( window.innerWidth < 1024 ) {
			return;
		}

		if (this.scrollTrigger) {
			this.scrollTrigger = {
				trigger: this.el,
				start: "clamp(top bottom)",
			};
		}

		SplitText.create(this.el, {
			type: "words, chars",
			autoSplit: true,
			onSplit: (self) => {
				gsap.set(self.chars, { transformOrigin: "50% 100%" });
				gsap.fromTo(
					self.chars,
					{
						autoAlpha: 0,
						y: 96,
						scale: 0.46,
						rotateZ: () => gsap.utils.random(-14, 14),
					},
					{
						autoAlpha: 1,
						y: 0,
						scale: 1,
						rotateZ: 0,
						duration: 1.45,
						delay: 0.12,
						ease: "elastic.out(1.25, 0.62)",
						scrollTrigger: this.scrollTrigger,
						stagger: {
							amount: 0.8,
							from: "start",
						},
					},
				);
			},
		});
	}

	// Backward compatibility with older calls.
	reveaHeading() {
		this.revealHeading();
	}

	// Backward compatibility with older calls.
	reveaHeroHeading() {
		this.revealHeroHeading();
	}

	parallax() {
		if (window.innerWidth < 1024) return;

		const pictures = this.el.querySelectorAll("[data-anime-parallax]");

		if (pictures.length) {
			pictures.forEach((picture) => {
				gsap.from(picture, {
					y: picture.dataset.animeParallax == "-1" ? -80 : 80,
					scrollTrigger: {
						trigger: this.el,
						start: "top bottom",
						end: "bottom center",
						scrub: 1,
					},
				});
			});
		}
	}

	toggleClass() {
		ScrollTrigger.create({
			trigger: this.el,
			start: "+=100px bottom",
			onToggle: (self) => {
				if (self.isActive) {

					if(this.el.length){
						
						this.el.forEach((blockEl) => {
							if(blockEl.length){
								blockEl.classLst.add("anime-initialized");
							}
						});						

					}else{
						// this.el.classList.add("anime-initialized"); 
					}

					// this.el.length 
					// 	? this.el.forEach((blockEl) => blockEl.classList.add("anime-initialized"))
					// 	: this.el.classList.add("anime-initialized"); 
					
				}
			},
		});
	}

	hasScrolltrigger() {
		return window.innerHeight < this.el.getBoundingClientRect().top
			? true
			: false;
	}
}
